import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';

import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { togglePinnedFiltersState, selectBuyoutsPinnedFilters } from '@store';

import { useHasFilters } from 'hooks/common';
import { BUY_OUT_STAGE_OPTIONS } from 'components/buyout/constants';

export const useBuyOutFilterConfig = ({ assignees = [] }) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const pinnedFilters = useSelector(selectBuyoutsPinnedFilters);

  const filterCategories = useMemo(
    () => [
      {
        id: 'status',
        label: 'Stage',
        icon: RadioButtonUncheckedIcon,
        options: BUY_OUT_STAGE_OPTIONS,
        multiSelect: true,
      },
      {
        id: 'assignee',
        label: 'Assignee',
        icon: RadioButtonUncheckedIcon,
        options: [{ text: 'None', value: 'None' }, ...assignees],
        multiSelect: false,
      },
    ],
    [assignees]
  );

  const handlePinnedFilterSelect = (pinnedFilter) => {
    dispatch(togglePinnedFiltersState({ board: 'buyouts', pinnedFilter }));
  };

  const { hasFilters } = useHasFilters({
    pinnedFilters,
    omitParams: [
      'page',
      'view',
      'pageSize',
      'order',
      'orderBy',
      'query',
      'viewMode',
    ],
  });

  const currentFilters = useMemo(() => {
    const parseQueryValue = (value, delimiter = ',') => {
      if (!value) return [];
      if (typeof value === 'string') {
        return value.split(delimiter).filter(Boolean);
      }
      return Array.isArray(value) ? value : [];
    };

    return {
      status: parseQueryValue(router.query.status),
      assignee: parseQueryValue(router.query.assignee),
    };
  }, [router.query]);

  return {
    filterCategories,
    currentFilters,
    pinnedFilters,
    supportPinnedFilters: true,
    hasFilters,
    handlePinnedFilterSelect,
  };
};
